import styled from 'styled-components';
import { media } from 'src/components/base';
import { zindex } from 'src/ui/zindex';
import { Tooltip as TooltipComponent } from '@prisjakt/ui/tooltip';
import {
  ButtonText as ButtonTextComponent,
  TonalButton,
} from '@prisjakt/ui/button/variants';

export const StyledButton = styled(TonalButton)`
  width: 100%;
`;

export const StyledButtonText = styled(ButtonTextComponent).attrs({
  'data-test': 'ButtonText',
})`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: none;

  ${media.largeUp`
    display: inline;
  `}
`;

export const StyledTooltip = styled(TooltipComponent).attrs({ width: '180px' })`
  z-index: ${zindex.tooltip};
  flex: 0;
`;
